export default "__VITE_ASSET__w$CH$JB1__"